var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardHeart = function SvgCreditCardHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_9004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.197.1H4.837C2.217.1.085 2.225.085 4.841V35.23c0 2.615 2.131 4.74 4.754 4.74h44.36c2.621 0 4.753-2.124 4.753-4.74V4.84a4.75 4.75 0 00-4.754-4.74zM4.837 3.26h44.36c.872 0 1.585.712 1.585 1.581V11.7H3.253V4.84c0-.87.713-1.58 1.584-1.58zm44.36 33.549H4.837a1.587 1.587 0 01-1.584-1.58v-20.37h47.529v20.37c0 .869-.713 1.58-1.584 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M42.686 20.788a3.986 3.986 0 00-3.311 1.761 3.987 3.987 0 00-6.486-.177 3.96 3.96 0 00-.797 2.35c0 4.588 5.296 7.045 7.283 8.685 1.986-1.64 7.283-4.097 7.283-8.685a3.944 3.944 0 00-1.17-2.787 3.964 3.964 0 00-2.802-1.146v0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_9004"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54v40H0z"
  })))));
};
export default SvgCreditCardHeart;